export default "__VITE_ASSET__42500c4f__"